module.exports = __webpack_public_path__ + "img/webworthy-3.e164ea99.jpg";